(() => {
  // Unified cart discount handler. Uses document-level event delegation so
  // it survives DOM swaps when sections re-render (drawer + cart page both
  // use the same #discount-code-container / #applied-discounts IDs).

  function triggerCartUpdate() {
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.updateQuantity === 'function') {
      const qtyInput =
        document.getElementById('Drawer-quantity-1') ||
        document.getElementById('Quantity-1');
      if (qtyInput) {
        const currentQty = parseInt(qtyInput.value, 10) || 1;
        cartDrawerItems.updateQuantity(1, currentQty);
        return;
      }
      if (typeof cartDrawerItems.onCartUpdate === 'function') {
        cartDrawerItems.onCartUpdate();
        return;
      }
    }

    const cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      const qtyInput =
        document.getElementById('Quantity-1') ||
        document.getElementById('Drawer-quantity-1');
      if (qtyInput) {
        const currentQty = parseInt(qtyInput.value, 10) || 1;
        cartItems.updateQuantity(1, currentQty);
        return;
      }
      if (typeof cartItems.onCartUpdate === 'function') {
        cartItems.onCartUpdate();
      }
    }
  }

  async function setDiscount(code) {
    // Hit the /checkout?discount=CODE URL — this is the original pattern
    // used by the theme to apply/replace cart-level codes via AJAX. Shopify
    // validates the code server-side; valid codes get applied, invalid
    // codes (like REMOVE_SHOPIFY_CODE) effectively wipe any existing one.
    const target = code && code.length > 0 ? code : 'REMOVE_SHOPIFY_CODE';
    try {
      await fetch(`/checkout?discount=${encodeURIComponent(target)}`, {
        method: 'GET',
        credentials: 'same-origin',
      });
    } catch (e) { /* best-effort */ }
  }

  async function applyCode(code) {
    await setDiscount(code);
    triggerCartUpdate();
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const data = await res.json();
      const titles = new Set();
      (data.cart_level_discount_applications || []).forEach((d) =>
        titles.add(d.title.toUpperCase())
      );
      (data.items || []).forEach((item) => {
        (item.line_level_discount_allocations || []).forEach((a) =>
          titles.add(a.discount_application.title.toUpperCase())
        );
      });
      return titles.has(code.toUpperCase());
    } catch (e) {
      return true;
    }
  }

  async function removeDiscount() {
    await setDiscount('REMOVE_SHOPIFY_CODE');
    triggerCartUpdate();
  }

  function showError(container, text) {
    const el = container && container.querySelector('#discount-error-message');
    if (!el) return;
    el.style.display = 'block';
    el.textContent = text;
  }

  function clearError(container) {
    const el = container && container.querySelector('#discount-error-message');
    if (!el) return;
    el.style.display = 'none';
    el.textContent = '';
  }

  function bindOnce() {
    if (document.body.dataset.discountHandlerInit === 'true') return;
    document.body.dataset.discountHandlerInit = 'true';

    document.addEventListener('click', async (event) => {
      // Remove handler
      const removeBtn = event.target.closest('.remove-discount');
      if (removeBtn) {
        event.preventDefault();
        const pill = removeBtn.closest('.discount-pill');
        if (pill) pill.style.opacity = '0.5';
        await removeDiscount();
        return;
      }

      // Apply handler
      const applyBtn = event.target.closest('#apply-discount-btn');
      if (applyBtn) {
        event.preventDefault();
        const container = applyBtn.closest('#discount-code-container');
        const input = container && container.querySelector('#discount-input');
        if (!input) return;

        clearError(container);
        const code = input.value.trim();
        const strings = window.cartDiscountStrings || {};
        if (!code) {
          showError(container, strings.errorNoCode || 'Please enter a discount code.');
          return;
        }

        const originalText = applyBtn.textContent;
        applyBtn.disabled = true;
        applyBtn.textContent = originalText + '…';

        const accepted = await applyCode(code);
        applyBtn.disabled = false;
        applyBtn.textContent = originalText;
        if (!accepted) {
          showError(container, strings.errorInvalid || 'Discount code is invalid or not applicable.');
        } else {
          input.value = '';
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindOnce);
  } else {
    bindOnce();
  }
})();
